module.exports = __webpack_public_path__ + "img/InDieFerneSchweifen.74caa99b.jpg";